import { ScreenLoading } from '@/components/loading';
import { ScreenStacks } from '@/components/screens/stacks-screen';
import { useApplications } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function StacksPage() {
  const sp = useScreenProps();
  const { data: apps, isLoading, isError, error, refetch, isFetching } = useApplications();

  // Erro ANTES do loading: sem isso a tela fica em spinner infinito quando a
  // query falha (isLoading volta false, mas `apps` segue undefined).
  if (isError) {
    return (
      <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
        <ScreenStacks
          {...sp}
          apps={[]}
          error={
            error instanceof Error && error.message
              ? error.message
              : 'Não foi possível carregar as aplicações para montar a matriz de tecnologias.'
          }
          retrying={isFetching}
          onRetry={() => {
            void refetch();
          }}
        />
      </div>
    );
  }

  if (isLoading || !apps) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenStacks {...sp} apps={apps} />
    </div>
  );
}
